"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const mithril_1 = require("../../mithril");
const accordion_style_1 = require("./accordion.style");
function view(props, children) {
    var _a;
    return (0, mithril_1.m)('details', { className: accordion_style_1.CSS.container, open: props.open || undefined }, [
        (0, mithril_1.m)('summary', { className: accordion_style_1.CSS.header }, [
            (_a = props.icon) !== null && _a !== void 0 ? _a : null,
            (0, mithril_1.m)('span', [props.title, props.subtitle ? (0, mithril_1.m)('span', { className: accordion_style_1.CSS.subtitle }, [`(${props.subtitle})`]) : null]),
        ]),
        (0, mithril_1.m)('div', { className: accordion_style_1.CSS.body }, children),
    ]);
}
exports.Accordion = { view, CSS: accordion_style_1.CSS };
//# sourceMappingURL=accordion.js.map